import React from "react";
import { Link } from "react-router-dom";
import Logo from "../images/Logo.svg";
import "../styles/GlobalStyles.css";

const Footer = () => {
  return (
    <footer className="bg-[#F3F4F6] border-t border-gray-200 pt-4 pb-6 md:pt-12 md:pb-8 font-['Inter',sans-serif] w-full">
      <div className="max-w-[700px] md:max-w-[1200px] mx-auto px-4">

        {/* Logo + Links Row: stacked and centered on mobile/tablet, inline on larger screens */}
        <div className="flex flex-col items-center gap-4 md:gap-6 mb-6 md:mb-8">
          {/* Logo */}
          <img
            src={Logo}
            alt="Teacher Search Logo"
            className="h-[42px] w-[144px] md:h-[60px] md:w-auto object-contain"
          />

          {/* Links */}
          <div className="flex gap-4 sm:gap-6 md:gap-8 flex-wrap justify-center">
            <Link
              to="/about-us"
              className="text-gray-600 no-underline text-sm md:text-base font-normal hover:text-gray-800 transition-colors"
            >
              About us
            </Link>

            <Link
              to="/privacy-policy"
              className="text-gray-600 no-underline text-sm md:text-base font-normal hover:text-gray-800 transition-colors"
            >
              Privacy Policy
            </Link>

            <Link
              to="/terms-conditions"
              className="text-gray-600 no-underline text-sm md:text-base font-normal hover:text-gray-800 transition-colors"
            >
              Terms & Conditions
            </Link>
          </div>
        </div>

        {/* Social Icons */}
        <div className="flex justify-center gap-3 md:gap-4 mb-5 md:mb-6">
          {[{
            Icon: "Facebook",
            path: "M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z",
          }, {
            Icon: "Twitter",
            path: "M22.162 5.656a8.384 8.384 0 0 1-2.402.658A4.196 4.196 0 0 0 21.6 4c-.82.488-1.719.83-2.656 1.015a4.182 4.182 0 0 0-7.126 3.814 11.874 11.874 0 0 1-8.62-4.37 4.168 4.168 0 0 0-.566 2.103c0 1.45.738 2.731 1.86 3.481a4.168 4.168 0 0 1-1.894-.523v.052a4.185 4.185 0 0 0 3.355 4.101 4.21 4.21 0 0 1-1.89.072A4.185 4.185 0 0 0 7.97 16.65a8.394 8.394 0 0 1-6.191 1.732 11.83 11.83 0 0 0 6.41 1.88c7.693 0 11.9-6.373 11.9-11.9 0-.18-.005-.362-.013-.54a8.496 8.496 0 0 0 2.087-2.165z",
          }].map((social, index) => (
            <a
              key={index}
              href="/"
              aria-label={social.Icon}
              className="w-7 h-7 md:w-10 md:h-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-600"
            >
              <svg
                className="w-3.5 h-3.5 md:w-[18px] md:h-[18px]"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d={social.path} />
              </svg>
            </a>
          ))}
        </div>

        {/* Copyright */}
        <div className="text-center text-sm text-gray-500">
          © 2025{" "}
          <span className="font-semibold text-gray-700">
            TeacherSearch.
          </span>{" "}
          All rights reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;
